import { gql } from '@apollo/client';

export const QUERY_DUPLICATE_DOCUMENT_NUMBERS = gql`
    query getDuplicateDocumentNumberFlag($documentNumberInput: String!, $partnerNumberInput: String!){
        getDuplicateDocumentNumberFlag(documentNumberInput: $documentNumberInput, partnerNumberInput: $partnerNumberInput){
            duplicateDocumentNumberInCurrentYearWarning
        }
    }
`;